import React from 'react'
import PropTypes from 'prop-types'

import { withRouter } from 'react-router-dom'

import { Event } from '../../../../../entities/Event'

import { DocumentAsset } from '../../../../components/DocumentAsset/DocumentAsset'
import EventHeader from './EventHeader/EventHeader'
import { EventInfo } from './EventInfo/EventInfo'
import EventContactsSection from './EventContactsSection/EventContactsSection'

import './SingleEvent.css'

const SingleEvent = ({ event }) => {
    const {
        eventImage,
        eventImageSource,
        htmlContent,
        htmlContentShort,
        hasDocuments,
        documents
    } = event

    return (
        <article className="single-event">
            <EventHeader event={event} />

            {eventImage && (
                <div
                    className="single-event__image"
                    style={{ backgroundImage: `url("${eventImage}")` }}
                >
                    <div className="single-event__image__source">{eventImageSource}</div>
                </div>
            )}

            <EventInfo event={event} />

            <p className="single-event__content" dangerouslySetInnerHTML={htmlContentShort} />
            <p className="single-event__content" dangerouslySetInnerHTML={htmlContent} />

            {hasDocuments && (
                <div className="single-event__assets">
                    {documents.map(doc => (
                        <DocumentAsset asset={doc} key={doc.name} />
                    ))}
                </div>
            )}

            {event.hasContacts && <EventContactsSection contactList={event.contacts} />}
        </article>
    )
}

SingleEvent.propTypes = {
    event: PropTypes.instanceOf(Event)
}

export default withRouter(SingleEvent)
